export default {
    excess: 'Deducible por daños en caso de siniestro',
    security: 'Deposito en garantía adicional al monto a pagar',
    fuel_policy: 'Política de repostaje',
    like_for_like: 'Equivalente',
    full_to_full: 'Devolución del depósito lleno',
    mileage: 'Combustible: {mileage} millas por alquiler',
    unlimited_mileage: 'Kilometraje libre',
    non_refundable: 'No reembolsable',
    free_cancellation_until: 'Cancelación gratuita hasta las {date}',
    cancellation_with_terms: 'Cancelación {0} de acorde con los ',
    t_c_text: 'términos y condiciones',
    two_free_extras: 'Dos extras gratis durante la recogida',
    glass_tyres_covered: 'Lunas y neumáticos cubiertos'
}
